<div class="d-flex">
  <div class="format-container">
    <div class="width-100">
      <mat-radio-group
        [value]="selectedShapeOption"
        (change)="setSelectedShapeOption($event.value)"
      >
        <div class="d-flex">
          <div
            *ngFor="let shapeOption of SHAPE_OPTIONS_ARRAY"
            class="format-column"
          >
            <mat-radio-button [value]="shapeOption">
              <span class="strong">{{ shapeOption.label }}</span>
            </mat-radio-button>
          </div>
        </div>
      </mat-radio-group>
    </div>

    <div class="d-flex upper-space">
      <div class="format-column">
        <mat-radio-group
          [disabled]="selectedShapeOption !== SHAPE_OPTIONS.LYING_DOWN"
          (change)="setSelectedHeightWidth($event.value)"
        >
          <div *ngFor="let heightWidthOption of lyingDownOptions">
            <mat-radio-button
              [value]="heightWidthOption"
              [checked]="
                selectedHeightWidth?.height === heightWidthOption.height &&
                selectedHeightWidth?.width === heightWidthOption.width
              "
              >{{ heightWidthOption.display }}</mat-radio-button
            >
          </div>
        </mat-radio-group>
      </div>
      <div class="format-column">
        <mat-radio-group
          [disabled]="selectedShapeOption !== SHAPE_OPTIONS.SQUARE"
          (change)="setSelectedHeightWidth($event.value)"
        >
          <div *ngFor="let heightWidthOption of squareOptions">
            <mat-radio-button
              [value]="heightWidthOption"
              [checked]="
                selectedHeightWidth?.height === heightWidthOption.height &&
                selectedHeightWidth?.width === heightWidthOption.width
              "
              >{{ heightWidthOption.display }}</mat-radio-button
            >
          </div>
        </mat-radio-group>
      </div>
      <div class="format-column">
        <mat-radio-group
          [disabled]="selectedShapeOption !== SHAPE_OPTIONS.UPRIGHT"
          (change)="setSelectedHeightWidth($event.value)"
        >
          <div *ngFor="let heightWidthOption of uprightOptions">
            <mat-radio-button
              [value]="heightWidthOption"
              [checked]="
                selectedHeightWidth?.height === heightWidthOption.height &&
                selectedHeightWidth?.width === heightWidthOption.width
              "
              >{{ heightWidthOption.display }}</mat-radio-button
            >
          </div>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div class="shape-container">
    <div>
      <div
        *ngIf="selectedShapeOption === SHAPE_OPTIONS.LYING_DOWN"
        class="spaced centered"
      >
        <div class="bordered">
          <div class="white-space"></div>
          <div class="rectangled-horizontal subtitle-white">Liggend</div>
        </div>
      </div>

      <div
        *ngIf="selectedShapeOption === SHAPE_OPTIONS.SQUARE"
        class="spaced centered"
      >
        <div class="square subtitle-white">Vierkant</div>
      </div>

      <div
        *ngIf="selectedShapeOption === SHAPE_OPTIONS.UPRIGHT"
        class="spaced centered"
      >
        <div class="bordered d-flex">
          <div class="rectangled-vertical subtitle-white">Staand</div>
          <div class="white-vertical"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="small-upper-space">
  <textarea-input
    [initContent]="standardStickerPart.layoutDescription"
    [placeholder]="'Extra info'"
    [client]="true"
    (answer)="layoutDescriptionChanged($event)"
  ></textarea-input>
</div>
